import { Grid } from '@mui/material'
import { styled } from '@mui/system'

const KeyboardGrid = styled(Grid)({
  justifyContent: 'center'
})

export default KeyboardGrid
